import styled, { css } from 'styled-components';

export const Form = styled.form`
  font-size: 14px;
  font-family: 'Inter';
  margin-bottom: 40px;
`;

export const FormSection = styled.section`
  display: flex;
  flex-direction: column;

  & > .MuiFormControl-root {
    margin: 0;
  }

  & > .MuiFormControl-root + .MuiFormControl-root {
    margin-top: 32px;
  }

  .MuiFormControlLabel-label {
    font-size: 14px;
  }

  .MuiFormHelperText-root {
    font-size: 12px;
    line-height: 1;
    height: 0;
    margin: 8px 14px 0;
  }

  & + & {
    margin-top: 40px;
  }

  a.terms-link {
    color: #758391;
    text-decoration: underline !important;
  }
`;

export const Title = styled.div`
  color: #141414;
  font-size: 30px;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;
  font-family: 'Inter';
  margin-bottom: 28px;
`;

export const SubTitle = styled.div`
  color: #141414;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  font-family: 'Inter';
  margin-bottom: 32px;
`;

export const SectionTitle = styled.div`
  color: #141414;
  font-size: 18px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 24px;
`;

export const Interest = styled.div`
  display: flex;
  padding: 16px;
  height: 51px;
  text-transform: capitalize;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;

  & + & {
    border-top: 1px solid #d9d9d9;
  }
`;

export const InterestsWrapper = styled.div<{ hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 427px;
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  box-sizing: border-box;

  ${(props) =>
    props.hasError &&
    css`
      border-color: #d32f2f;
      .MuiTypography-root {
        color: #d32f2f;
      }
      ${Interest} {
        border-color: #d32f2f;
      }
    `}
`;

export const Confirmation = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 427px;
  width: 100%;
`;

export const ContactUs = styled.div`
  font-size: 14px;
  font-family: Inter;
  color: #141414;

  a {
    color: #758391;
    text-decoration: underline !important;
  }
`;
